import React from "react";

import { ImageComponent } from "@tm/static";
import { useBreakpointV2 } from "@tm/ui-widgets";

import { Card } from "../../OrderDetailV2.style";
import { useOrderDetailV2 } from "../../OrderDetailV2Context";
import type { OrderDetailV2EndorsementNudgeProps } from "../../types";
import { OrderDetailV2Tooltip } from "../OrderDetailV2Tooltip";
import {
  NudgeCardContent,
  NudgeCtaButton,
  NudgeDescription,
  NudgeIcon,
  NudgeMobileIconCta,
  NudgeRow,
  NudgeText,
  NudgeTitle,
} from "./OrderDetailV2EndorsementNudge.style";

export const OrderDetailV2EndorsementNudge: React.FC<
  OrderDetailV2EndorsementNudgeProps
> = ({ title, description, icon, actions }) => {
  const { openEditTravellers } = useOrderDetailV2();
  const device = useBreakpointV2();
  const action = actions?.[0];

  if (!title && !description) {
    return null;
  }

  const disabled = !action?.isEnabled;

  const handleAction = () => {
    if (disabled) {
      return;
    }
    openEditTravellers?.();
  };

  const ctaTooltip = (child: React.ReactNode) => (
    <OrderDetailV2Tooltip
      message={action?.disabledReason || ""}
      trigger="both"
      show={disabled}
      position="bottom"
      autoHideDelay={5000}
      disabled={!disabled || !action?.disabledReason}
    >
      {child}
    </OrderDetailV2Tooltip>
  );

  return (
    <Card>
      <NudgeCardContent>
        <NudgeRow>
          {icon && (
            <NudgeIcon>
              <ImageComponent src={icon} width="38px" height="38px" />
            </NudgeIcon>
          )}
          <NudgeText>
            {title && <NudgeTitle>{title}</NudgeTitle>}
            {description && <NudgeDescription>{description}</NudgeDescription>}
          </NudgeText>
          {action?.isVisible &&
            action.text &&
            device === "lg" &&
            ctaTooltip(
              <NudgeCtaButton
                type="button"
                disabled={disabled}
                onClick={handleAction}
                aria-label={action.text}
              >
                {action.text}
              </NudgeCtaButton>
            )}
          {action?.isVisible &&
            action.icon &&
            device === "sm" &&
            ctaTooltip(
              <NudgeMobileIconCta
                type="button"
                disabled={disabled}
                onClick={handleAction}
                aria-label={action.text}
              >
                <ImageComponent src={action.icon} width="24px" height="24px" />
              </NudgeMobileIconCta>
            )}
        </NudgeRow>
      </NudgeCardContent>
    </Card>
  );
};
